import {ErrorMessage, Field, Form, Formik} from 'formik'
import {KTSVG} from '../../../helpers'
import * as Yup from 'yup'
import {useState} from 'react'
import {useParams} from 'react-router-dom'
import {getRequest} from '../../../../app/pages/Helpers/Requests'

const validationSchema = Yup.object({
  version: Yup.string().required('Version is required'),
})

function GetVersionDetails() {
  const [data, setData] = useState<any>(null)
  let {pointId} = useParams()
  const initialValues = {
    version: '',
  }

  const handleSubmit = async (values: any) => {
    try {
      const res = await getRequest(`/ocpi/msp/${pointId}/versions/${values.version}`)
      console.log('versions details response', res)
      if (res && res.data) {
        setData(res.data.data)
      }
    } catch (error: any) {
      console.error('Error fetching version details:', error)
    }
  }

  return (
    <div className='modal fade' tabIndex={-1} id='get_version_details'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header bg-success'>
            <h5 className='modal-title text-white'>Get Version Details</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-success ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {() => (
                <Form>
                  <div className='row'>
                    <div className='col-md-12 mt-3'>
                      <label className='form-label'>Version</label>
                      <Field name='version' className='form-control' />
                      <ErrorMessage name='version' component='div' className='text-danger' />
                    </div>
                  </div>

                  {/* Show Data Table */}
                  {data && (
                    <div className='mt-4'>
                      <h6>Version: {data.version}</h6>
                      <table className='table table-bordered table-striped'>
                        <thead>
                          <tr>
                            <th>Identifier</th>
                            <th>Role</th>
                            <th>URL</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.data?.endpoints?.map((ep: any, index: number) => (
                            <tr key={index}>
                              <td>{ep.identifier}</td>
                              <td>{ep.role}</td>
                              <td>
                                <a href={ep.url} target='_blank' rel='noreferrer'>
                                  {ep.url}
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className='modal-footer mt-3'>
                    <button type='button' className='btn btn-light-danger' data-bs-dismiss='modal'>
                      Cancel
                    </button>
                    <button type='submit' className='btn btn-light-success'>
                      Submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetVersionDetails
